import { useEffect } from 'react';

export const DEFAULT_PORTAL_TITLE = 'Coffee Chats - School Portal';

export const schoolPortalTitle = (schoolName) => {
  const name = String(schoolName || '').trim();
  return name ? `Coffee Chats - ${name}` : DEFAULT_PORTAL_TITLE;
};

/**
 * Keep the browser tab tied to the resolved public institution identity. The
 * generic title remains only for routes where no school has been resolved.
 */
export function usePortalDocumentTitle(schoolName) {
  useEffect(() => {
    const title = schoolPortalTitle(schoolName);
    document.title = title;
    return () => {
      if (document.title === title) { document.title = DEFAULT_PORTAL_TITLE; }
    };
  }, [schoolName]);
}

export default usePortalDocumentTitle;
